import { useState, useCallback, useEffect } from "react";
import { getClient } from "../lib/client.js";

/**
 * Fournit une fonction `fetchClient(idClient)` pour charger un client à la demande et expose `{ client, loading, error, fetchClient }`.
 *
 * @returns {{ client: object|null, loading: boolean, error: string|null, fetchClient: Function }}
 */
export function useGetClient() {
  const [client, setClient] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

 
  
  const fetchClient = useCallback(async (idClient) => {
    try {
      setLoading(true);
      setError(null);
      const data = await getClient(idClient);
      setClient(data);
      return data;
    } catch (err) {
      setError(err.message || "Erreur lors de la récupération du client");
      return null;
    } finally {
      setLoading(false);
    }
  }, []);

  return {
    client,
    loading,
    error,
    fetchClient,
  };
}
